import React, { useState, useEffect, createContext, useContext } from "react";
import { usePost } from "seed/api";
import { Loading } from "seed/helpers";
import { useAuth } from "components/util/helpers/providers/AuthProvider";

const ThemeContext = createContext(undefined);

const useTheme = ({ checkContext = true } = {}) => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    if (checkContext)
      throw new Error("useTheme must be used within a ThemeProvider");
    return {};
  }
  return context;
}

const ThemeProvider = ({ children }) => {

  const user = useAuth(); // TODO: Also get themes from useFlow
  const [theme, setTheme] = useState(null);

  const [callTheme] = usePost("/users/get_theme", {
    onCompleted: (data) =>
      setTheme(data)
  })

  useEffect(() => {
    if (user)
      callTheme();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  if (user && !theme)
    return <Loading />;

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );

}

export { ThemeProvider, useTheme };